// extracted by mini-css-extract-plugin
export var actionButton = "_9h-0";
export var attachmentLine = "_9h-1";
export var fileInput = "_9h-2";
export var fileUploadWrapper = "_9h-4";
export var footer = "_9h-3";
export var modalContent = "_9h-5";
export var paperclip = "_9h-6";
export var quillEditor = "_9h-7";